import { fetchBatchSysDicList, fetchAllBank, getAllGuaOrg, fetchBusiList, getAllBank, fetchAuditFormatId } from "@/http/dictionary"
import { getOrgPage, JobRankQuery } from '@/http/api';

const isObject = (v) => Object.prototype.toString.call(v) === '[object Object]'

const enumData = {
  $area: {//获取地区
    catalogName: 'Area',
    sys: 'BasicData'
  },
  $projectType: { //获取工程类型
    catalogName: 'ProjectType',
    sys: 'BasicData'
  },
  $perStatus: { //履约订单状态
    catalogName: 'OrderStatus',
    sys: 'Performance'
  },
  $changePriceStatus: { //履约改价状态
    catalogName: 'ChangePriceStatus',
    sys: 'Performance'
  },
  $perProjectType: { //项目类型
    catalogName: 'ProjectType',
    sys: 'Performance'
  },
  $perGuaranteeType: { //保函品种
    catalogName: 'GuaranteeType',
    sys: 'Performance'
  },
  $perFormatType: { //格式类型字段
    catalogName: 'FormatTypeCategory',
    sys: 'BasicData'
  },
  $refundType: { //退款类型
    catalogName: 'RefundType',
    sys: 'Performance'
  },
  $refundStatus: { //退款状态
    catalogName: 'RefundStatus',
    sys: 'Performance'
  },
  $suspendType: { //挂起类别
    catalogName: 'SuspendType',
    sys: 'Performance'
  },
  $projectTypeCategory: { //获取项目分类
    catalogName: 'ProjectTypeCategory',
    sys: 'BasicData'
  },
  $groupType: { //获取分组字典
    catalogName: 'GroupType',
    sys: 'Bidding'
  },
  $ReimburseSubject: { //获取报销科目
    catalogName: 'ReimburseSubject',
    sys: 'Financial'
  },
  $limitCompany: { //出函公司主体
    catalogName: 'LimitCompanyName',
    sys: 'Performance'
  },
  $orderTeamTypes: { //订单类型
    catalogName: 'OrderTeamTypes',
    sys: 'BasicData'
  },
  $payMethods: { //获取付款方式枚举
    catalogName: 'PaymentMethod',
    sys: 'Bidding'
  },
  $InvoicingEntity: { //发票开票主体
    catalogName: 'InvoicingEntity',
    sys: 'Performance'
  },
  $InvoicingEntityold: { //发票开票主体old
    catalogName: 'InvoicingEntityold',
    sys: 'Performance'
  },
  $CommissionLevel: { //提成等级
    catalogName: 'CommissionLevel',
    sys: 'BasicData'
  },
  $sourceType: { //订单来源
    catalogName: 'SourceType',
    sys: 'BasicData'
  },
  $InvoiceType: { //获取开票类型
    catalogName: 'InvoiceType',
    sys: 'Financial'
  },
  $RedConfirmState: { //获取红字确认单状态
    catalogName: 'RedConfirmState',
    sys: 'Financial'
  },
  $guaOrg: async function () { //出函机构
    return await getAllGuaOrg()
  },
  $perBankArr: async function () { //非转开银行
    return await fetchAllBank()
  },
  $businessArr: async function () { //获取所有业务员
    return await fetchBusiList()
  },
  $auditFormatId: async function () { //获取待上传格式ID
    return await fetchAuditFormatId()
  },
  $getAllBank: async function () { //获取所有银行的列表
    return await getAllBank()
  },
  $orgList: async function () { //组织架构
    return await getOrgPage()
  },
  $JobRankTypes: async function (k) { // 获取所有的岗位
    return await JobRankQuery()
  }
}

const mountPrototypeData = async function (Vue) {
  const mapData = new Map()
  let dictionaryData = []
  const commonEnumData = JSON.parse(localStorage.getItem('commonEnumData') || "{}")
  for (let k in enumData) {
    if (Vue.prototype[k]) continue
    let v = enumData[k]
    if (isObject(v)) {
      if (commonEnumData[k]) {
        Vue.prototype[k] = commonEnumData[k]
        continue
      }
      dictionaryData.push(v)
      mapData.set(JSON.stringify(v), k) // 映射k值
    }
    if (typeof v === 'function') {
      const data = commonEnumData[k] || await v()
      Vue.prototype[k] = data
      commonEnumData[k] = data
      localStorage.setItem('commonEnumData', JSON.stringify(commonEnumData))
    }
  }
  dictionaryData.length && fetchBatchSysDicList(dictionaryData).then(res => {
    res.forEach(({ catalogName, sys, Data }) => {
      let k = mapData.get(JSON.stringify({ catalogName, sys }))
      commonEnumData[k] = Data
      Vue.prototype[k] = Data
      localStorage.setItem('commonEnumData', JSON.stringify(commonEnumData))
    })
  })
}

export default mountPrototypeData




